import { useCallback } from 'react';
import { useApiPatch } from '@sierralabs/core-ui';
export function useUpdateReport(reportId) {
    const { data, isLoading, error, patch } = useApiPatch(`reports/${reportId}`);
    const updateReport = useCallback((dto) => patch(dto), [patch]);
    return {
        updatedReport: data,
        updatingReport: isLoading,
        updatingReportError: error,
        updateReport
    };
}
//# sourceMappingURL=useUpdateReport.js.map